import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import FalconCardHeader from 'components/common/FalconCardHeader';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import TableRowAction from 'components/common/TableRowAction';
import { weDonorInvoiceData } from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Card, Carousel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const DonorGiving = () => {
  const [activeSlider, setActiveSlider] = useState(0);
  const [activeSlider2, setActiveSlider2] = useState(0);
  const data = [1, 2, 3];

  let { pathname } = useLocation();

  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { ref } = rowData.row.original;
        return <Link to={`${pathname}/${ref}`}>{ref}</Link>;
      }
    },
    {
      accessor: 'item',
      Header: 'Item',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'date',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'pay_method',
      Header: 'Pay Method',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        return (
          <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
            {rowData.row.original.status}{' '}
            <FontAwesomeIcon icon={rowData.row.original.icon} />
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'id',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row;
        return (
          <TableRowAction
            onCLickEdit={() => console.log(id)}
            onCLickDelete={() => console.log(id)}
          />
        );
      }
    }
  ];

  return (
    <>
      <Card className="mb-3">
        <FalconCardHeader
          title={<h4 className="mt-2 fw-bold">Giving</h4>}
          light={false}
          titleTag="div"
          menuClassName="align-items-center"
          endEl={
            <IconButton icon="plus" transform="shrink-3">
              <span className="d-none d-md-inline-block ms-2">
                Add Donation
              </span>
            </IconButton>
          }
        />
      </Card>

      <Row className="g-3 mb-3">
        <Col md={6}>
          <Card>
            <Carousel
              controls={false}
              interval={2000}
              className="donor-carousel"
              onSlide={id => setActiveSlider(id)}
            >
              {data?.map(item => (
                <Carousel.Item key={item}>
                  <FalconCardHeader
                    title={
                      <p className="fs-0 mb-0">
                        Regular Donations{' '}
                        <FontAwesomeIcon
                          icon={'question-circle'}
                          className="text-400 ms-2"
                        />
                      </p>
                    }
                    light={false}
                    titleTag="div"
                    className="pb-1"
                    menuClassName="align-items-start"
                    endEl={
                      <IconButton
                        icon="pen"
                        variant="falcon-default"
                        className="fs--1 bg-transparent shadow-none p-0"
                      />
                    }
                  />

                  <Card.Body className="pt-0 pb-5">
                    <p className="fs-2 text-primary fw-medium mb-2">
                      $250.00 <span className="fs--1 text-700">(RG10001)</span>
                    </p>
                    <p className="mb-2">
                      <FontAwesomeIcon
                        icon={'user'}
                        className="text-primary me-1"
                      />
                      Regular Giving - Monthly
                    </p>
                    <p className="mb-0">
                      <FontAwesomeIcon
                        icon={'credit-card'}
                        className="text-primary me-1"
                      />
                      Credit Card xx241
                    </p>
                  </Card.Body>
                </Carousel.Item>
              ))}
            </Carousel>
            <p className="mb-0 donor-carousel-counter fw-medium">
              {activeSlider + 1} of {data.length}
            </p>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Carousel
              controls={false}
              interval={2500}
              className="donor-carousel"
              onSlide={id => setActiveSlider2(id)}
            >
              {data?.map(item => (
                <Carousel.Item key={item}>
                  <FalconCardHeader
                    title={
                      <p className="fs-0 mb-0">
                        Pledges{' '}
                        <FontAwesomeIcon
                          icon={'question-circle'}
                          className="text-400 ms-2"
                        />
                      </p>
                    }
                    light={false}
                    titleTag="div"
                    className="pb-1"
                    menuClassName="align-items-start"
                    endEl={
                      <IconButton
                        icon="pen"
                        variant="falcon-default"
                        className="fs--1 bg-transparent shadow-none p-0"
                      />
                    }
                  />

                  <Card.Body className="pt-0 pb-5">
                    <p className="fs-2 text-primary fw-medium mb-2">
                      $950.00{' '}
                      <span className="fs--1 text-700">/ $ 1,000.00</span>
                    </p>

                    <p className="mb-2">
                      <FontAwesomeIcon
                        icon={'credit-card'}
                        className="text-primary me-1"
                      />
                      PL100002 - Pledge
                    </p>
                    <p className="mb-0">
                      <FontAwesomeIcon
                        icon={'check-circle'}
                        className="text-success me-1"
                      />
                      Completed
                    </p>
                  </Card.Body>
                </Carousel.Item>
              ))}
            </Carousel>
            <p className="mb-0 donor-carousel-counter fw-medium">
              {activeSlider2 + 1} of {data.length}
            </p>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weDonorInvoiceData}
            columns={columns}
            title="Invoices"
            showSearchInput
            searchInputPlaceHolder="Search"
            addNew={false}
          />
        </Col>
      </Row>
    </>
  );
};

export default DonorGiving;
